var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.166 11.5h1.667v1.666H8.166zm0-6.667h1.667v5H8.166zM8.991.666C4.391.666.666 4.399.666 8.999s3.725 8.334 8.325 8.334c4.608 0 8.342-3.734 8.342-8.334S13.599.666 8.99.666m.008 15a6.665 6.665 0 0 1-6.666-6.667 6.665 6.665 0 0 1 6.666-6.666 6.665 6.665 0 0 1 6.667 6.666 6.665 6.665 0 0 1-6.667 6.667"
  })));
};
export { SvgAlert as Icon };
export default __webpack_public_path__ + "static/media/00ca64efb88774607b0a6ff5a8762ee3.svg";